<template></template>

<script>
export default {
  name: 'TawkWidget',
  mounted() {
    if (!window.Tawk_API) {
      const s1 = document.createElement('script');
      s1.async = true;
      s1.src = this.$store.state.setting?.tawk_src;
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');
      const s0 = document.getElementsByTagName('script')[0];
      s0.parentNode.insertBefore(s1, s0);
    }
  }
};
</script>